import { render, staticRenderFns } from "./customView.vue?vue&type=template&id=670f223c&scoped=true"
import script from "./customView.vue?vue&type=script&lang=js"
export * from "./customView.vue?vue&type=script&lang=js"
import style0 from "./customView.vue?vue&type=style&index=0&id=670f223c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f223c",
  null
  
)

export default component.exports